import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../api';

export default function AdminTemplates() {
  const [templates, setTemplates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [repeatInterval, setRepeatInterval] = useState('');
  const [repeatCount, setRepeatCount] = useState(2);
  const [submitting, setSubmitting] = useState(false);

  function refresh() {
    api.listAllTemplates().then(setTemplates).catch(() => toast.error("Couldn't load templates."));
  }

  useEffect(refresh, []);

  async function handleCreate(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.createTemplate(name, description, repeatInterval || null, repeatInterval ? repeatCount : null);
      toast.success('Template created');
      setName('');
      setDescription('');
      setRepeatInterval('');
      setRepeatCount(2);
      setShowForm(false);
      refresh();
    } catch {
      toast.error("Couldn't create the template.");
    } finally {
      setSubmitting(false);
    }
  }

  async function toggleActive(template) {
    try {
      await api.updateTemplate(template.id, { is_active: !template.is_active });
      refresh();
    } catch {
      toast.error("Couldn't update that template.");
    }
  }

  return (
    <div className="page">
      <h1>Manage templates</h1>
      <button onClick={() => setShowForm((v) => !v)}>{showForm ? 'Cancel' : 'Add template'}</button>

      {showForm && (
        <form className="card" onSubmit={handleCreate}>
          <label>
            Name
            <input value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label>
            Description
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} />
          </label>
          <label>
            Repeat
            <select value={repeatInterval} onChange={(e) => setRepeatInterval(e.target.value)}>
              <option value="">Doesn't repeat</option>
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
            </select>
          </label>
          {repeatInterval && (
            <label>
              Number of times
              <input
                type="number"
                min={2}
                value={repeatCount}
                onChange={(e) => setRepeatCount(e.target.value)}
              />
            </label>
          )}
          <button type="submit" disabled={submitting}>
            {submitting ? 'Adding…' : 'Add'}
          </button>
        </form>
      )}

      <ul className="user-list">
        {templates.map((t) => (
          <li key={t.id} className="user-row">
            <div>
              <div className="task-title">{t.name}</div>
              <div className="hint">
                {t.repeat_interval ? `Repeats ${t.repeat_interval}, ${t.repeat_count}x` : 'No repeat'}
                {!t.is_active && ' · retired'}
              </div>
            </div>
            <button onClick={() => toggleActive(t)}>
              {t.is_active ? 'Retire' : 'Reactivate'}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
